import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';

// Renders workshop title/description text authored with <RichTextField> —
// **bold**, *italic*, <u>underline</u>, and single-Enter line breaks.
// `inline` keeps it to a single line (used inside titles/subtitles) instead
// of wrapping paragraphs in <p> tags.
export default function MarkdownText({ text, inline = false, as, style, className }) {
  const Wrapper = as || (inline ? 'span' : 'div');
  return (
    <Wrapper style={style} className={className}>
      {text && (
        <ReactMarkdown
          remarkPlugins={[remarkBreaks]}
          rehypePlugins={[rehypeRaw]}
          components={{
            p: ({ children }) => inline ? <>{children}</> : <p style={{ margin: '0 0 8px' }}>{children}</p>,
          }}
        >
          {text}
        </ReactMarkdown>
      )}
    </Wrapper>
  );
}
